import { RG_TYPE } from '../../types/rg-type.js';

const DefaultPlot = {
    type: RG_TYPE.Plot,
    data: {
        zonePolyIndex: 0,
        polygon: [[-10, 0, -10], [10, 0, -10], [5, 0, 5], [-10, 0, -10]]
    },
    children: []
};

export { DefaultPlot };
//# sourceMappingURL=default-plot.js.map
